import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';

//Model
import { Search } from './search.model';

//Service
import { SearchService } from './search.service'
import { ComponentsSettingsService } from '../../services/components_settings.service';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ SearchService, ComponentsSettingsService ]
})
export class SearchComponent implements OnInit {

  public searchKeys: Search[];
  public searchKey: Search;
  public result : number = 0;
  public frmSearch:FormGroup;
  public show: any;

  constructor(private fb : FormBuilder,
    private searchService : SearchService,
    public router: Router,
    public route: ActivatedRoute,
    private svc_component : ComponentsSettingsService) { }

  ngOnInit() {
    this.frmSearch = this.fb.group({
      searchText: '',
    });
    
    let role_id = this.svc_component.access_role;
    this.getSearchKeys(role_id);
  }

  public getSearchKeys(role_id) {
    this.searchService.getSearchKeysByRoleId(role_id).subscribe(data => {
        this.searchKeys = data["search_keys"];
        this.result = this.searchKeys.length;

      });
	}

}
